import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate("/admin");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#0C0A09] flex items-center justify-center px-6" data-testid="login-page">
      <Link to="/" className="absolute top-8 left-8 label link-underline flex items-center gap-2" data-testid="login-back-link">
        <ArrowLeft size={14} /> Back to site
      </Link>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.19, 1, 0.22, 1] }}
        className="w-full max-w-md border border-[#292524] rounded-sm p-10 bg-[#1C1917]/40"
      >
        <p className="font-serif text-3xl text-[#F5F5F0] tracking-tight">
          Ave<span className="text-[#C4A47C]">.</span>luxe
        </p>
        <p className="label mt-2 mb-8">Studio Admin</p>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="label block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email"
              className="w-full bg-[#0C0A09] border border-[#292524] focus:border-[#C4A47C] outline-none rounded-sm px-4 py-3 text-[#F5F5F0] transition-colors"
              placeholder="admin@aveluxecandles.com"
            />
          </div>
          <div>
            <label className="label block mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
              className="w-full bg-[#0C0A09] border border-[#292524] focus:border-[#C4A47C] outline-none rounded-sm px-4 py-3 text-[#F5F5F0] transition-colors"
              placeholder="••••••••"
            />
          </div>
          {error && <p className="text-sm text-[#D89797]" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#C4A47C] hover:bg-[#D8BC97] disabled:opacity-60 text-[#0C0A09] px-6 py-3.5 text-sm font-medium transition-colors"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            Sign in
          </button>
        </form>
      </motion.div>
    </div>
  );
}
